"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSmallScreen = isSmallScreen;
function isSmallScreen() {
  return window.matchMedia && !window.matchMedia('(min-width: 380px)').matches;
}
